<template>
    <div>
        <menu-bar v-if="menu"/>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/reservas-tecnicas"><i class="fa fa-suitcase" aria-hidden="true"></i> RESERVAS TÉCNICAS</a></li>
                    <li class="active">CADASTRO DE RESERVAS TÉCNICAS</li>
                </ol>

                <div class="col-md-3">
                    <voltar-menu v-if="menu" :url="'#/reservas-tecnicas'" />
                </div>

                <div class="col-md-9" v-if="reserva">
                    <form class="form-horizontal" >

                        <div class="panel panel-info">
                            <!-- Default panel contents -->
                            <div class="panel-heading">
                                <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                            </div>

                            <div class="panel-body">
                                <div class="form-group">

                                    <div class="col-sm-12">
                                        <label for="nome" :class="{'text-danger': !reserva.nome}" class="control-label">NOME DA RESERVA</label>
                                        <input id="nome" disabled type="text" v-model.number="reserva.nome" class="form-control" >
                                    </div>

                                    <div class="col-sm-12">
                                        <label for="obs" class="control-label">OBS DA RESERVA TÉCNICA</label>
                                        <textarea id="obs" rows="5" v-model="reserva.obs" class="form-control" ></textarea>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <place :place.sync="reserva.place" :height="'500px'" />

                        <div class="form-group">
                            <div class="col-sm-10">
                                <button type="button" v-if="user.level < 5"
                                        @click="save()"
                                        class="btn btn-success">
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR RESERVA TÉCNICA
                                </button>
                            </div>
                        </div>

                    </form>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { ReservaTecnica } from "../../../class/index";
import { VoltarMenu, Place } from "../../../components/exports";

export default {
    components: { VoltarMenu, Place },
    data() {
        return {
            menu: true,
            user: null,
            reserva: null
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.query.disable_menu === "1") {
            this.menu = false;
        }
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        } else if (this.$route.params.lat && this.$route.params.lng) {
            this.reserva = ReservaTecnica.create();
            this.reserva.place = [
                Number(this.$route.params.lng),
                Number(this.$route.params.lat)
            ];
            this.menu = false;
        } else {
            this.reserva = ReservaTecnica.create();
        }
    },
    beforeDestroy() {
        console.log("reserva tecnica off");
    },
    methods: {
        async loadPonto() {
            let r = await ReservaTecnica.byID(this._id);
            if (!r.obs) {
                r.obs = null;
            }
            this.reserva = r;
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a reserva?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            ReservaTecnica.save(this.reserva)
                                .then(() => {
                                    resolve();
                                    if (this.menu) {
                                        this.$router.push({
                                            path: "/reservas-tecnicas"
                                        });
                                    } else {
                                        window.close();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
